<!-- 'attr.component-id' for QA selectors -->
<cc-lazy-host [componentId]="componentId" [attr.component-id]="componentId" [providers]="providers" />
